
<template>
  <div class="article-list">
    <div
      style="
        width: 92%;
        position: fixed;
        z-index: 99999;
        background: rgb(220, 220, 220);
        padding: 8px 15px;
      "
    >
      <div class="article-list-head c-s">
        <div class="list-head-title"  @click="seachAll">
          {{ this.$route.query.title }}
          <img :class="iconLoading?'active_img':'refresh_msg_style'" src="../assets/images/images/refresh_msg.png" alt />
        </div>
        <div class="list-head-search">
          <van-cell-group>
            <van-field autosize v-model="whatSearch" placeholder="搜索关键词" />
          </van-cell-group>
          <img v-if="whatSearch" src="../assets/images/images/closeTC.png" class="closeTc" @click="seachAll"/>
          <div
            v-if="!active"
            class="search-img c-e van-hairline--left"
            style="display: flex; justify-content: center"
          >
            <img
              src="../assets/images/images/cchc1.png"
              @touchend="gtouchend()"
              @touchstart="gtouchstart()"
              @click="search"
              alt
            />
          </div>
          <div
            v-else
            class="search-img c-e van-hairline--left"
            style="display: flex; justify-content: center"
          >
            <img
              src="../assets/images/images/cchc2.png"
              @touchend="gtouchend()"
              @touchstart="gtouchstart()"
              @click="search"
              alt
            />
          </div>
        </div>
      </div>
    </div>

    <div style="padding: 8px 15px">
      <div style="height: 50px"></div>
      <div class="category_title_list" v-if="keyWordsAndCategory.keywords">
				<div v-for="(item) in keyWordsAndCategory.keywords" :key="item.id" @click="tapKeyWord(item.name)">{{item.name}}</div>
			</div>
      <template>
        <RecomendShopInClass2 :leftDay="leftDay" :vipStatus="vipStatus" :cid="cid"></RecomendShopInClass2>
      </template>

      <!--广告图-->
      <div v-if="topAdvertisementUrl.thumb_url" style="position:relative;">
        <img :src="topAdvertisementUrl.thumb_url" @click="goDatails(topAdvertisementUrl.url)"/>
        <img class="handPoint" src="../assets/images/images/jumpHand.png" @click="goDatailPage()" />
      </div>

      <template>
        <van-tabs
          @click="clickTabs"
          v-if="cid == 10"
          style="padding-top: 0 !important"
          v-model="activeName"
        >
          <van-tab
            v-for="(item, index) in nav"
            :title="item.title"
            :key="index"
          ></van-tab>
        </van-tabs>
      </template>
      <div class="list-content">
        <div class="key_words_list" v-if="cid != 10 && keyWordsAndCategory.children && keyWordsAndCategory.children.length > 0">
					<div :class="category == item.id ? 'category-active':'' " v-for="(item) in keyWordsAndCategory.children" :key="item.id" @click="clickTabs2(item)">{{item.title}}</div>
				</div>
        <div v-if="superRecomedList.length != 0 && !hasSearch">
          <HeadItemForOne
            style="margin-top: 8px"
            v-for="(item, index) in superRecomedList"
            typeP='super'
            :key="index"
            :mes="item"
            :bigPic="is_big_pic?true:false"
          ></HeadItemForOne>
        </div>
        <div v-if="recommondList.length != 0">
          <HeadItemForOne
            style="margin-top: 8px"
            v-for="(item, index) in recommondList"
            :key="index"
            :mes="item"
            :bigPic="is_big_pic?true:false"
          ></HeadItemForOne>
        </div>
        <div style="margin-top: 10px">
          <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="searchIng?'加载中...':'没有更多了'"
            @load="onLoad"
          >
            <HeadItemWithoutZD
              style="margin-top: 8px"
              v-for="(item, index) in articleList"
              :key="index"
              :mes="item"
              :bigPic="is_big_pic?true:false"
            ></HeadItemWithoutZD>
          </van-list>
        </div>
      </div>
      <BackTop></BackTop>
      <HomeTab></HomeTab>
      <div class="orderInfo">
        <div @click="orderInfo">订阅</div>
        <div @click="connectKF">客服</div>
        <div @click="setTop">首页</div>
      </div>
       <!--二维码弹窗-->
      <div class="codeTc" v-if="showCode">
        <div @click="closeCode">
          <img src="../assets/images/images/closeCode.png" alt="" />
        </div>
        <div class="codeContent">
          <img :src="preImg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import HomeTab from "../components/HomeTab";
import BackTop from "../components/BackTop";
import { getData,postData } from "../Interface/http.js";
import HeadItemForOne from "../components/HeadItemForOne.vue";
import HeadItemWithoutZD from "../components/HeadItemWithoutZD.vue";
import RecomendShopInClass2 from "../components/recomedShopInClass2.vue";
export default {
  name: "About",
  data() {
    return {
      iconLoading: false,
      images: [],
      orderImg: [],
      showCode: false,
      preImg: '',
      vipStatus: {},
      cid: "",
      activeName: 0,
      active: false,
      articleList: [],
      recommondList: [],
      page: 1,
      category: "",
      loading: false,
      finished: false,
      whatSearch: "",
      nav: [],
      topAdvertisementUrl: {},//顶部广告信息
      hasSearch: false, //是否启用搜索
      searchIng: false, //是否正在搜索
      jumpPageUrl: "",
      userInfoData:"",
      scroll: 0,
      leftDay: {
        type: ''
      }, //VIP剩余多少天数
      is_big_pic: false,
      superRecomedList: [],//超级推荐的帖子列表
      keyWordsAndCategory: {}, //关键词及二级分类信息
    };
  },
  components: {
    HeadItemForOne,
    HeadItemWithoutZD,
    HomeTab,
    BackTop,
    RecomendShopInClass2,
  },
  beforeRouteLeave(to, from, next) {
      if (to.name === 'sendMessage' || to.name === 'errorReport' || to.name === 'shopDetailInfo') {
          // from.meta.keepAlive = true;
      } else {
          // from.meta.keepAlive = false;
          this.removeKeepAliveCache.call(this);
      }
      next();
  },
  mounted() {
    let token = localStorage.getItem("token");
    if (!token) {
      getData("/oauth/redirect/wechat").then((res) => {
        localStorage.setItem("pageparams", window.location.href);
        localStorage.setItem("startPage", "about");
        window.location.href = res.data.redirect_url;
      });
    }
    this.getUserStatus();
    this.getVipTimeOut();
    this.category = this.$route.query.id;
    this.cid = this.$route.query.id;
    this.activeName = this.$route.query.id - 10;
    this.$store.commit("UPDATEATBINDEX", { tag: this.$route.query.active - 0 });
    this.getRecommondList();
    this.getActions();
    this.getProvide();
    this.getTopAdvertisement(this.category,1);
    this.getCategoryAndKeyWords();
    this.getSuperRecomedPost();
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    removeKeepAliveCache () {
        if (this.$vnode && this.$vnode.data.keepAlive && this.$vnode.parent) {
            const tag = this.$vnode.tag;
            let caches = this.$vnode.parent.componentInstance.cache;
            let keys = this.$vnode.parent.componentInstance.keys;
            for (let [key, cache] of Object.entries(caches)) {
                if (cache.tag === tag) {
                    if (keys.length > 0 && keys.includes(key)) {
                        keys.splice(keys.indexOf(key), 1);
                    }
                    delete caches[key];
                }
            }
        }
        this.$destroy();
    },
    tapKeyWord(keyWord) {
      console.log(keyWord);
			this.whatSearch = keyWord;
			this.search();
		},
    //其他分类切换
		clickTabs2(item) {
      if(this.iconLoading) {
        return;
      }
			this.whatSearch = '';
			this.category = item.id == this.category? this.cid: item.id;
			if(item.is_big_pic == '1') {
				this.is_big_pic = true;
			} else {
				this.is_big_pic = false;
			}
			this.seachAll();
		},
    setTop() {
      this.$router.replace('/home');
    },
    getCategoryAndKeyWords() {
			let me = this;
      getData(`/category-info?cid=${me.cid}`).then(res => {
        if(res.code == 0) {
          let result = res.data[0] || {};
						if(result.is_big_pic == '1') { //判断是否打开大图模式
							me.is_big_pic = true;
						}
						if(result.children && result.children.length > 0) {
							result.children.unshift({
								id: me.cid,
								title: '全部',
								is_big_pic: result.is_big_pic
							})
						}
						me.keyWordsAndCategory = result;
        }
      })
		},
    selectKFImg() {
      let me = this;
      getData("/recommend-lists?position=7")
        .then((res) => {
          if (res.code == 0) {
            var arr = [];
            arr = res.data.map((item) => {
              return item.banner.thumb_url;
            });
            me.images.push(...arr);
          }
        })
        .catch((err) => {});
    },
    selectOrderImg() {
      //获取订阅图片
      let me = this;
      getData("/recommend-lists?position=10").then((res) => {
        me.orderImg = res.data;
      });
    },
    //关闭二维码
    closeCode() {
      let me = this;
      me.showCode = false;
    },
    //展示订阅二维码
    orderInfo() {
      let me = this;
      me.preImg = me.orderImg[0].banner.thumb_url;
      this.$nextTick(function () {
        me.showCode = true;
      });
    },
    //展示客服二维码
    connectKF() {
      let me = this;
      me.preImg = me.images[0];
      this.$nextTick(function () {
        me.showCode = true;
      });
    },
    //查询会员到期时间
    getVipTimeOut() {
      let me = this;
      getData("/vip/check-validity-date")
        .then((res) => {
          me.leftDay = Object.assign({},res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取用户当前的开通状态
    getUserStatus() {
      let me = this;
      postData("/vip/is-pay", {
        type: "store",
      })
        .then((res) => {
          me.vipStatus = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleScroll() {
      this.scroll = document.documentElement && document.documentElement.scrollTop;
    },
    //获取置顶的超级推荐信息
    getSuperRecomedPost() {
      let me = this;
      getData(`/smart/top?category=${this.category}`)
        .then((res) => {
          me.superRecomedList = res.data;
        })
        .catch((err) => {
        });
    },
    //页面跳转
    goDatails(url) {
      if (!url) {
        return;
      }
      if (!url.includes("jfbst.com")) {
        Dialog.confirm({
          message:
            "您将进入第三方平台。相关服务和责任将由该第三方承担。如有问题请咨询该平台客服",
        }).then(() => {
          window.location.href = url;
        });
      } else {
        window.location.href = url;
      }
    },
    //获取顶部广告位
    getTopAdvertisement(id, position) {
      let me = this;
      getData(`/recommend-adverts?random=1&category_id=${id}&position=${position}`, {
        token: localStorage.getItem("token")
          ? localStorage.getItem("token")
          : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
      })
        .then((res) => {
          me.jumpPageUrl = res.data[0].page_url;
          me.topAdvertisementUrl = res.data[0].advert;
        })
        .catch((err) => {
        });
    },
    //跳转到广告页列表
    goDatailPage() {
      window.location = this.jumpPageUrl;
    },
    getUserInfo() {
      let me = this;
      return new Promise((resolve, reject) => {
        getData("/user/info", {
          token: localStorage.getItem("token")
            ? localStorage.getItem("token")
            : "jpMfzc9oh7SVC3Koac1QZz3Mh7KyngKd",
        })
          .then((res) => {
            if (res.code == 0) {
              me.userInfoData = Object.assign({}, res.data);
              sessionStorage.setItem("userInfoData", JSON.stringify(res.data));
            }
            resolve();
          })
          .catch((err) => {
            resolve();
          });
      })
    },
    gtouchstart() {
      this.active = true;
    },
    gtouchend() {
      this.active = false;
    },
    //切换分类
    clickTabs(index) {
      this.whatSearch = "";
      this.category = this.nav[index].id;
      this.page = 1;
      this.articleList = [];
      this.recommondList = [];
      this.seachAll();
    },
    // 栏目供求
    getProvide() {
      getData("recommend-categories").then((res) => {
        let arr = { id: 10, title: "全部" };
        res.data.unshift(arr);
        for (let i = 0; i < res.data.length; i++) {
          for (let j = i; j < res.data.length; j++) {
            if (res.data[i].id > res.data[j].id) {
              let t = new Object();
              t = res.data[i];
              res.data[i] = res.data[j];
              res.data[j] = t;
            }
          }
        }
        this.nav = res.data;
      });
    },
    getActions() {
      getData("/report/options", {}).then((res) => {
        this.$store.commit("UPDATEACTIONS", { actions: res.data });
      });
    },
    async onLoad() {
      let token = localStorage.getItem("token");
      if(!sessionStorage.getItem("userInfoData") || !token) {
        await this.getUserInfo();
      }
      if(this.hasSearch) {
        this.searchIng = false;
        return;
      }
      this.selectKFImg();
      this.selectOrderImg();
      let url = "messages";
      getData(url, {
        page: this.page,
        category: this.category,
        keyword: this.whatSearch
      }).then((res) => {
        this.loading = false;
        this.page++;
        if (res.data.length != 0) {
          res.data.map((a) => {
            this.articleList.push(a);
          });
        } else {
          this.finished = true;
        }
        this.searchIng = false;
      }).catch(err => {
        this.loading = false;
        this.finished = true;
        this.searchIng = false;
      });
    },
    seachAll() {
      this.whatSearch = "";
      this.iconLoading = true;
      setTimeout(() => {
        this.iconLoading = false;
      },2000)
      this.search();
      this.getSuperRecomedPost();
    },
    search() {
      this.articleList = [];
      this.recommondList = [];
      this.searchIng = true;
      this.loading = true;
      this.page = 1;
      if(this.whatSearch.length==0){
        this.hasSearch = false;
        this.finished = false;
        this.getRecommondList();
        this.onLoad();
        return;
      }else {
        this.hasSearch = true;
      }
      getData("search-message", {
        keyword: this.whatSearch,
        category: this.category,
        page: this.page,
      }).then((res) => {
        this.articleList = res.data;
        this.searchIng = false;
        this.finished = true;
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        this.finished = true;
        this.searchIng = false;
      });
    },
    async getRecommondList() {
      let token = localStorage.getItem("token");
      if(!sessionStorage.getItem("userInfoData") || !token) {
        await this.getUserInfo();
      }
      getData("recommend-messages", {
        category: this.category,
      }).then((res) => {
        if (res.data.length != 0) {
          this.recommondList = res.data;
        } else {
          this.recommondList = [];
        }
      });
    },
  },
  computed: {
    aboutMessages() {
      if (JSON.stringify(this.$store.state.aboutMessage) != "{}") {
        return this.$store.state.aboutMessage;
      } else {
        return JSON.parse(sessionStorage.getItem("aboutMessage"));
      }
    },
  },
  activated() {
    let that = this;
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => {
      document.documentElement.scrollTop = that.scroll;
    })
  },
  deactivated() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped>
.active_img {
	width: 20px;
	height: 20px;
	margin-left: 8px;
	animation: rotate 1s linear infinite;
}
   
  @keyframes rotate {
	from {
	  transform: rotate(0deg);
	}
	to {
	  transform: rotate(360deg);
	}
  }
  .refresh_msg_style {
    width: 20px;
    height: 20px;
    margin-left: 8px;
    }
.handPoint {
  position: absolute;
  z-index: 22;
  right: 10px;
  top: 50%;
  width: 30px;
  height: 30px;
  transform: translateY(-50%);
}
.closeTc {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.article-list {
  min-height: 100vh;
  box-sizing: border-box;
  background: rgb(220, 220, 220);
}
.article-list-head {
  width: 100%;
}
.list-head-title {
  font-size: 18px;
  display: flex;
  align-items: center;
  color: #000;
}
.list-head-search {
  display: flex;
  align-items: center;
  width: 225px;
  height: 35px;
  border-radius: 5px;
  background: #fff;
  overflow: hidden;
  border: 2px solid #5e328c;
}
.list-head-search >div:nth-child(1) {
  flex-grow: 1;
  width: 0;
  flex-shrink: 0;
}
.key_words_list {
	display: flex;
  margin-top: 6px;
	background-color: #fff;
	padding: 7px 0;
}
.category-active {
	background-color: #882784 !important;
	color: #fff !important;
}
.key_words_list div {
	flex-shrink: 0;
	width: 0;
	margin: 0 4px;
	flex-grow: 1;
	font-size: 12px;
	border-radius: 6px;
	padding: 4px 8px;
	border: 1px solid #882784;
	color: #882784;
	display: flex;
	align-items: center;
	justify-content: space-around;
}
.category_title_list {
	display: flex;
	overflow-x: scroll;
}
.category_title_list div {
	flex-shrink: 0;
	padding: 5px 10px;
	margin-left: 6px;
	margin-top: 6px;
	font-size: 12px;
	border-radius: 14px;
	background-color: rgb(230, 230, 230);
	color: rgb(93, 92, 92);
}

.search-img {
  flex-shrink: 0;
  width: 35px;
  height: 24px;
}
.search-img img {
  width: 23px;
  height: 23px;
}
.van-tabs--line {
  padding-top: 10px !important;
}
.orderInfo {
  position: fixed;
  left: -5px;
  top: 65%;
  z-index: 99;
}

.orderInfo div {
  background-color: #882784;
  font-size: 15px;
  color: #fff;
  opacity: 0.7;
  padding: 10px;
  margin-top: 5px;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  line-height: 17px;
}
.codeTc {
  position: fixed;
  top: 50%;
  left: 50%;
  min-height: 220px;
  width: 220px;
  z-index: 99999;
  background-color: #f5f5f5;
  opacity: 0.9;
  transform: translate(-50%, -50%);
  border-radius: 5px;
}
.codeTc > div:nth-child(1) {
  position: absolute;
  right: 5px;
  top: 5px;
}
.codeTc > div:nth-child(1) img {
  width: 20px;
  height: 20px;
}
.codeContent {
  width: 100%;
  height: 200px;
  padding: 20px 0;
  display: flex;
  justify-content: center;
}
.codeContent img {
  width: 150px;
  height: 200px;
}
</style>
